import { render, staticRenderFns } from "./add-article.vue?vue&type=template&id=1f12717f&scoped=true"
import script from "./add-article.vue?vue&type=script&lang=js"
export * from "./add-article.vue?vue&type=script&lang=js"
import style0 from "./add-article.vue?vue&type=style&index=0&id=1f12717f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f12717f",
  null
  
)

export default component.exports